// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");

function scrollY() {
  return window.scrollY;
}

function scrollX() {
  return window.scrollX;
}

function setScroll(x, y) {
  window.scroll(x, y);
}

function scrollPosition() {
  return [
    window.scrollX,
    window.scrollY
  ];
}

function scrollToTop() {
  setScroll(0, 0);
}

function toJs(v) {
  return {
    behavior: v.behavior,
    block: v.block
  };
}

let Options = {
  toJs: toJs
};

function scrollToHash(hash, options, param) {
  let location = hash !== undefined ? hash : window.location.hash;
  if (location === "") {
    return;
  }
  let match = document.querySelector(location);
  if (!(match == null)) {
    if (options !== undefined) {
      match.scrollIntoView(toJs(options));
    } else {
      match.scrollIntoView();
    }
    return;
  }
}

function isElementInView(element) {
  let boundingRect = element.getBoundingClientRect();
  if (boundingRect.top >= 0 && boundingRect.left >= 0 && boundingRect.right <= window.innerWidth) {
    return boundingRect.bottom <= window.innerHeight;
  } else {
    return false;
  }
}

function scrollToHashIfNeeded(hash, options, param) {
  let location = hash !== undefined ? hash : window.location.hash;
  if (location === "") {
    return;
  }
  let match = Stdlib_Option.map(Primitive_option.fromNullable(document.querySelector(location)), el => [
    el,
    isElementInView(el)
  ]);
  if (match === undefined) {
    return;
  }
  if (match[1]) {
    return;
  }
  let el = match[0];
  if (options !== undefined) {
    el.scrollIntoView(toJs(options));
  } else {
    el.scrollIntoView();
  }
}

let Location;

exports.Location = Location;
exports.scrollY = scrollY;
exports.scrollX = scrollX;
exports.setScroll = setScroll;
exports.scrollPosition = scrollPosition;
exports.scrollToTop = scrollToTop;
exports.Options = Options;
exports.scrollToHash = scrollToHash;
exports.isElementInView = isElementInView;
exports.scrollToHashIfNeeded = scrollToHashIfNeeded;
/* No side effect */
